import { Locale } from 'chaika-enums';
export const templateModule = {
    editBlock: {
        [Locale.Ru]: `Редактирование блока`,
        [Locale.Am]: `Բլոկի խմբագրում`,
        [Locale.En]: `Editing a block`,
        [Locale.Pt]: 'Editando um bloco',
        [Locale.Ge]: `Editing a block`,
    },
    selectFieldToEdit: {
        [Locale.Ru]: `Выберите поле для редактирования`,
        [Locale.Am]: `Ընտրեք դաշտը խմբագրելու համար`,
        [Locale.En]: `Select a field to edit`,
        [Locale.Pt]: 'Selecione um campo para editar',
        [Locale.Ge]: `აირჩიეთ ველი რედაქტირებისთვის`,
    },
    deleteConditionConfirm: {
        [Locale.Ru]: `Вы действительно хотите удалить состояние:\n«$name»`,
        [Locale.Am]: `Իսկապե՞ս ուզում եք ջնջել վիճակը՝\n«$name»`,
        [Locale.En]: `Do you really want to delete the condition:\n"$name"`,
        [Locale.Pt]: 'Deseja realmente excluir a condição:\n"$name"',
        [Locale.Ge]: `ნამდვილად გსურთ მდგომარეობის წაშლა:\n„$name“`,
    },
    unsavedFieldChangesConfirm: {
        [Locale.Ru]: `Вы внесли изменения в «$name».\nПри выходе изменения не сохранятся.\nВы действительно хотите закончить редактирование?`,
        [Locale.Am]: `Դուք փոփոխություններ եք կատարել «$name»-ում։\nԴուրս գալիս փոփոխությունները չեն պահպանվի։\nԻսկապե՞ս ուզում եք ավարտել խմբագրումը`,
        [Locale.En]: `You have changed "$name".\nThe changes will not be saved on exit.\nDo you really want to finish editing?`,
        [Locale.Pt]: 'Você alterou "$name".\nAs alterações não serão salvas ao sair.\nDeseja realmente terminar a edição?',
        [Locale.Ge]: `თქვენ შეცვალეთ „$name“.\nგასვლისას ცვლილებები არ შეინახება.\nნამდვილად გსურთ რედაქტირების დასრულება?`,
    },
    conditionNesting: {
        [Locale.Ru]: `Вложенность`,
        [Locale.Am]: `Ներդրվածություն`,
        [Locale.En]: `Nesting`,
        [Locale.Pt]: 'Aninhamento',
        [Locale.Ge]: `ჩალაგება`,
    },
    conditionsChangedElsewhere: {
        [Locale.Ru]: `Данные изменились в другом месте.\nОбновите страницу, чтобы увидеть актуальные состояния.`,
        [Locale.Am]: `Տվյալները փոփոխվել են այլ տեղում։\nԹարմացրեք էջը՝ արդի վիճակները տեսնելու համար։`,
        [Locale.En]: `The data has changed elsewhere.\nReload the page to see the current conditions.`,
        [Locale.Pt]: 'Os dados foram alterados em outro lugar.\nRecarregue a página para ver as condições atuais.',
        [Locale.Ge]: `მონაცემები სხვაგან შეიცვალა.\nგანაახლეთ გვერდი მიმდინარე მდგომარეობების სანახავად.`,
    },
    conditionShortHeading: {
        [Locale.Ru]: `Короткое название`,
        [Locale.Am]: `Կարճ անվանում`,
        [Locale.En]: `Short name`,
        [Locale.Pt]: 'Nome curto',
        [Locale.Ge]: `მოკლე დასახელება`,
    },
    addCondition: {
        [Locale.Ru]: `Добавить состояние`,
        [Locale.Am]: `Ավելացնել վիճակ`,
        [Locale.En]: `Add condition`,
        [Locale.Pt]: 'Adicionar condição',
        [Locale.Ge]: `მდგომარეობის დამატება`,
    },
    newCondition: {
        [Locale.Ru]: `Новое состояние`,
        [Locale.Am]: `Նոր վիճակ`,
        [Locale.En]: `New condition`,
        [Locale.Pt]: 'Nova condição',
        [Locale.Ge]: `ახალი მდგომარეობა`,
    },
    systemFields: {
        [Locale.Ru]: `Системные поля`,
        [Locale.Am]: `Համակարգային դաշտեր`,
        [Locale.En]: `System fields`,
        [Locale.Pt]: 'Campos do sistema',
        [Locale.Ge]: `System fields`,
    },
    computedFields: {
        [Locale.Ru]: `Вычислимые поля`,
        [Locale.Am]: `Հաշվարկվող դաշտեր`,
        [Locale.En]: `Computed fields`,
        [Locale.Pt]: 'Campos computados',
        [Locale.Ge]: `Computed fields`,
    },
    editEntryType: {
        [Locale.Ru]: `Редактирование типа записи`,
        [Locale.Am]: `Գրառման տեսակի խմբագրում`,
        [Locale.En]: `Editing a entry type`,
        [Locale.Pt]: 'Editando um tipo de entrada',
        [Locale.Ge]: `Editing a entry type`,
    },
    addSection: {
        [Locale.Ru]: `Добавить раздел`,
        [Locale.Am]: `Ավելացնել բաժին`,
        [Locale.En]: `Add section`,
        [Locale.Pt]: 'Adicionar seção',
        [Locale.Ge]: `Add section`,
    },
    systemName: {
        [Locale.Ru]: `Системное название`,
        [Locale.Am]: `Համակարգային անվանում`,
        [Locale.En]: `System name`,
        [Locale.Pt]: 'Nome do sistema',
        [Locale.Ge]: `System name`,
    },
    blockList: {
        [Locale.Ru]: `Список блоков`,
        [Locale.Am]: `Բլոկների ցանկ`,
        [Locale.En]: `Block list`,
        [Locale.Pt]: 'Lista de bloqueios',
        [Locale.Ge]: `Block list`,
    },
    dictionaryList: {
        [Locale.Ru]: `Список словарей`,
        [Locale.Am]: `Բառարանների ցանկ`,
        [Locale.En]: `List of dictionaries`,
        [Locale.Pt]: 'Lista de dicionários',
        [Locale.Ge]: `List of dictionaries`,
    },
    addElement: {
        [Locale.Ru]: `Добавить элемент`,
        [Locale.Am]: `Ավելացնել տարր`,
        [Locale.En]: `Add element`,
        [Locale.Pt]: 'Adicionar elemento',
        [Locale.Ge]: `Add element`,
    },
    entryTypeList: {
        [Locale.Ru]: `Список типов записей`,
        [Locale.Am]: `Գրառումների տեսակների ցանկ`,
        [Locale.En]: `List of entry types`,
        [Locale.Pt]: 'Lista de tipos de entrada',
        [Locale.Ge]: `List of entry types`,
    },
    dentalFormula: {
        [Locale.Ru]: `Зубная формула`,
        [Locale.Am]: `Ատամնաբանաձև`,
        [Locale.En]: `Dental formula`,
        [Locale.Pt]: 'Fórmula dentária',
        [Locale.Ge]: `Dental formula`,
    },
    toTemplates: {
        [Locale.Ru]: `К шаблонам`,
        [Locale.Am]: `Դեպի ձևանմուշներ`,
        [Locale.En]: `To templates`,
        [Locale.Pt]: 'Para modelos',
        [Locale.Ge]: `To templates`,
    },
    createCopy: {
        [Locale.Ru]: `Создать копию`,
        [Locale.Am]: `Ստեղծել պատճեն`,
        [Locale.En]: `Create copy`,
        [Locale.Pt]: 'Criar cópia',
        [Locale.Ge]: `Create copy`,
    },
    copySingle: {
        [Locale.Ru]: `Копия`,
        [Locale.Am]: `Պատճեն`,
        [Locale.En]: `Copy`,
        [Locale.Pt]: `Copiar`,
        [Locale.Ge]: `Copy`,
    },
    cm3: {
        [Locale.Ru]: `cм³`,
        [Locale.Am]: `սմ³`,
        [Locale.En]: `cm³`,
        [Locale.Pt]: 'cm³',
        [Locale.Ge]: `cm³`,
    },
    volume: {
        [Locale.Ru]: `Объем`,
        [Locale.Am]: `Ծավալ`,
        [Locale.En]: `Volume`,
        [Locale.Pt]: 'Volume',
        [Locale.Ge]: `Volume`,
    },
    BMI: {
        [Locale.Ru]: `ИМТ`,
        [Locale.Am]: `ՄԶԻ`,
        [Locale.En]: `BMI`,
        [Locale.Pt]: 'IMC',
        [Locale.Ge]: `BMI`,
    },
    kgm2: {
        [Locale.Ru]: `кг/м²`,
        [Locale.Am]: `կգ/մ²`,
        [Locale.En]: `kg/m²`,
        [Locale.Pt]: 'kg/m²',
        [Locale.Ge]: `kg/m²`,
    },
    dateOfBirth: {
        [Locale.Ru]: `Дата родов`,
        [Locale.Am]: `Ծննդաբերության ամսաթիվ`,
        [Locale.En]: `Date of birth`,
        [Locale.Pt]: 'Data de nascimento',
        [Locale.Ge]: `Date of birth`,
    },
    copyField: {
        [Locale.Ru]: `Копировать поле`,
        [Locale.Am]: `Պատճենել դաշտը`,
        [Locale.En]: `Copy field`,
        [Locale.Pt]: 'Copiar campo',
        [Locale.Ge]: `Copy field`,
    },
    order: {
        [Locale.Ru]: `Порядок`,
        [Locale.Am]: `Հերթականություն`,
        [Locale.En]: `Order`,
        [Locale.Pt]: 'Ordem',
        [Locale.Ge]: `Order`,
    },
    orderSecond: {
        [Locale.Ru]: `Заказ`,
        [Locale.Am]: `Պատվեր`,
        [Locale.En]: `Order`,
        [Locale.Pt]: 'Ordem',
        [Locale.Ge]: `Order`,
    },
    through: {
        [Locale.Ru]: `Сквозное`,
        [Locale.Am]: `Անընդմեջ`,
        [Locale.En]: `Through`,
        [Locale.Pt]: 'Através',
        [Locale.Ge]: `Through`,
    },
    onlyForWoman: {
        [Locale.Ru]: `Отображать только для женщин`,
        [Locale.Am]: `Ցուցադրել միայն կանանց համար`,
        [Locale.En]: `Display for women only`,
        [Locale.Pt]: 'Exibição apenas para mulheres',
        [Locale.Ge]: `Display for women only`,
    },
    inherited: {
        [Locale.Ru]: `Наследуемое`,
        [Locale.Am]: `Ժառանգվող`,
        [Locale.En]: `Inherited`,
        [Locale.Pt]: 'Herdado',
        [Locale.Ge]: `Inherited`,
    },
    placeholder: {
        [Locale.Ru]: `Плейсхолдер`,
        [Locale.Am]: `Պլեյսհոլդեր`,
        [Locale.En]: `Placeholder`,
        [Locale.Pt]: 'Espaço reservado',
        [Locale.Ge]: `Placeholder`,
    },
    headlineAtTop: {
        [Locale.Ru]: `Заголовок сверху`,
        [Locale.Am]: `Վերնագիրը վերևում`,
        [Locale.En]: `Headline at the top`,
        [Locale.Pt]: 'Título no topo',
        [Locale.Ge]: `Headline at the top`,
    },
    width: {
        [Locale.Ru]: `Ширина`,
        [Locale.Am]: `Լայնություն`,
        [Locale.En]: `Width`,
        [Locale.Pt]: 'Largura',
        [Locale.Ge]: `Width`,
    },
    label: {
        [Locale.Ru]: `Подпись`,
        [Locale.Am]: `Պիտակ`,
        [Locale.En]: `Label`,
        [Locale.Pt]: 'Rótulo',
        [Locale.Ge]: `Label`,
    },
    formula: {
        [Locale.Ru]: `Формула`,
        [Locale.Am]: `Բանաձև`,
        [Locale.En]: `Formula`,
        [Locale.Pt]: 'Fórmula',
        [Locale.Ge]: `Formula`,
    },
    milk: {
        [Locale.Ru]: `Молочная`,
        [Locale.Am]: `Կաթնատամ`,
        [Locale.En]: `Milk`,
        [Locale.Pt]: 'Leite',
        [Locale.Ge]: `Milk`,
    },
    permanent: {
        [Locale.Ru]: `Постоянная`,
        [Locale.Am]: `Մշտական`,
        [Locale.En]: `Permanent`,
        [Locale.Pt]: 'Permanente',
        [Locale.Ge]: `Permanent`,
    },
    anyDate: {
        [Locale.Ru]: `Любая дата`,
        [Locale.Am]: `Ցանկացած ամսաթիվ`,
        [Locale.En]: `Any date`,
        [Locale.Pt]: 'Qualquer data',
        [Locale.Ge]: `Aby date`,
    },
    pastOnly: {
        [Locale.Ru]: `Только прошлое`,
        [Locale.Am]: `Միայն անցյալ`,
        [Locale.En]: `Past only`,
        [Locale.Pt]: 'Passado apenas',
        [Locale.Ge]: `Past only`,
    },
    futureOnly: {
        [Locale.Ru]: `Только будущее`,
        [Locale.Am]: `Միայն ապագա`,
        [Locale.En]: `Future only`,
        [Locale.Pt]: 'Apenas futuro',
        [Locale.Ge]: `Future only`,
    },
    dateLimitation: {
        [Locale.Ru]: `Ограничение даты`,
        [Locale.Am]: `Ամսաթվի սահմանափակում`,
        [Locale.En]: `Date limitation`,
        [Locale.Pt]: 'Limitação de data',
        [Locale.Ge]: `Date limitation`,
    },
    mask: {
        [Locale.Ru]: `Маска`,
        [Locale.Am]: `Դիմակ`,
        [Locale.En]: `Mask`,
        [Locale.Pt]: 'Máscara',
        [Locale.Ge]: `Mask`,
    },
    withComment: {
        [Locale.Ru]: `С комментарием`,
        [Locale.Am]: `Մեկնաբանությամբ`,
        [Locale.En]: `With comment`,
        [Locale.Pt]: 'Com comentário',
        [Locale.Ge]: `With comment`,
    },
    tableLayout: {
        [Locale.Ru]: `Схема таблицы`,
        [Locale.Am]: `Աղյուսակի սխեմա`,
        [Locale.En]: `Table layout`,
        [Locale.Pt]: 'Layout da mesa',
        [Locale.Ge]: `Table layout`,
    },
    table: {
        [Locale.Ru]: `Таблица`,
        [Locale.Am]: `Աղյուսակ`,
        [Locale.En]: `Table`,
        [Locale.Pt]: `Tabela`,
        [Locale.Ge]: `Table`,
    },
    cellData: {
        [Locale.Ru]: `Данные ячейки`,
        [Locale.Am]: `Բջջի տվյալներ`,
        [Locale.En]: `cellData`,
        [Locale.Pt]: 'dados da célula',
        [Locale.Ge]: `cellData`,
    },
    text: {
        [Locale.Ru]: `Текст`,
        [Locale.Am]: `Տեքստ`,
        [Locale.En]: `Text`,
        [Locale.Pt]: 'Texto',
        [Locale.Ge]: `Text`,
    },
    string: {
        [Locale.Ru]: `Строка`,
        [Locale.Am]: `Տող`,
        [Locale.En]: `String`,
        [Locale.Pt]: 'Corda',
        [Locale.Ge]: `String`,
    },
    selectComponent: {
        [Locale.Ru]: `Селект`,
        [Locale.Am]: `Սելեկտ`,
        [Locale.En]: `Select`,
        [Locale.Pt]: `Selecionar`,
        [Locale.Ge]: `Select`,
    },
    checkbox: {
        [Locale.Ru]: `Чекбокс`,
        [Locale.Am]: `Չեքբոքս`,
        [Locale.En]: `Checkbox`,
        [Locale.Pt]: 'Caixa de seleção',
        [Locale.Ge]: `Checkbox`,
    },
    hideCell: {
        [Locale.Ru]: `Скрывать ячейку`,
        [Locale.Am]: `Թաքցնել բջիջը`,
        [Locale.En]: `Hide cell`,
        [Locale.Pt]: 'Ocultar célula',
        [Locale.Ge]: `Hide cell`,
    },
    cellType: {
        [Locale.Ru]: `Тип ячейки`,
        [Locale.Am]: `Բջջի տեսակ`,
        [Locale.En]: `Cell type`,
        [Locale.Pt]: 'Tipo de célula',
        [Locale.Ge]: `Cell type`,
    },
    maximum: {
        [Locale.Ru]: `Максимальное`,
        [Locale.Am]: `Առավելագույն`,
        [Locale.En]: `Maximum`,
        [Locale.Pt]: 'Máximo',
        [Locale.Ge]: `Maximum`,
    },
    minimum: {
        [Locale.Ru]: `Минимальное`,
        [Locale.Am]: `Նվազագույն`,
        [Locale.En]: `Minimum`,
        [Locale.Pt]: 'Mínimo',
        [Locale.Ge]: `Minimum`,
    },
    valueForCell: {
        [Locale.Ru]: `значение для ячейки`,
        [Locale.Am]: `արժեք բջջի համար`,
        [Locale.En]: `value for cell`,
        [Locale.Pt]: 'valor para célula',
        [Locale.Ge]: `value for cell`,
    },
    defaultValue: {
        [Locale.Ru]: `Значение по умолчанию`,
        [Locale.Am]: `Լռելյայն արժեք`,
        [Locale.En]: `Default value`,
        [Locale.Pt]: 'Valor padrão',
        [Locale.Ge]: `Default value`,
    },
    columnCount: {
        [Locale.Ru]: `Кол-во колонок`,
        [Locale.Am]: `Սյուների քանակ`,
        [Locale.En]: `Number of columns`,
        [Locale.Pt]: 'Número de colunas',
        [Locale.Ge]: `Number of columns`,
    },
    rowCount: {
        [Locale.Ru]: `Кол-во строк`,
        [Locale.Am]: `Տողերի քանակ`,
        [Locale.En]: `Number of lines`,
        [Locale.Pt]: 'Número de linhas',
        [Locale.Ge]: `Number of lines`,
    },
    firstLineHeadings: {
        [Locale.Ru]: `Первая строчка - заголовки`,
        [Locale.Am]: `Առաջին տողը՝ վերնագրեր`,
        [Locale.En]: `First line - headings`,
        [Locale.Pt]: 'Primeira linha - títulos',
        [Locale.Ge]: `First line - headings`,
    },
    firstColumnHeaders: {
        [Locale.Ru]: `Первый столбец - заголовки`,
        [Locale.Am]: `Առաջին սյունը՝ վերնագրեր`,
        [Locale.En]: `First column - headings`,
        [Locale.Pt]: 'Primeira coluna - títulos',
        [Locale.Ge]: `First column - headings`,
    },
    fillingTemplates: {
        [Locale.Ru]: `Шаблоны заполнения`,
        [Locale.Am]: `Լրացման ձևանմուշներ`,
        [Locale.En]: `Filling templates`,
        [Locale.Pt]: 'Modelos de preenchimento',
        [Locale.Ge]: `Filling templates`,
    },
    addTemplate: {
        [Locale.Ru]: `Добавить шаблон`,
        [Locale.Am]: `Ավելացնել ձևանմուշ`,
        [Locale.En]: `Add template`,
        [Locale.Pt]: 'Adicionar modelo',
        [Locale.Ge]: `Add template`,
    },
    newSection: {
        [Locale.Ru]: `Новый раздел`,
        [Locale.Am]: `Նոր բաժին`,
        [Locale.En]: `New section`,
        [Locale.Pt]: 'Nova seção',
        [Locale.Ge]: `New section`,
    },
    emptySectionTitle: {
        [Locale.Ru]: `Без названия раздела`,
        [Locale.Am]: `Առանց բաժնի անվանման`,
        [Locale.En]: `Untitled section`,
        [Locale.Pt]: 'Seção sem título',
        [Locale.Ge]: `Untitled section`,
    },
    addBlock: {
        [Locale.Ru]: `Добавить блок`,
        [Locale.Am]: `Ավելացնել բլոկ`,
        [Locale.En]: `Add block`,
        [Locale.Pt]: 'Adicionar bloco',
        [Locale.Ge]: `Add block`,
    },
    enterBlockName: {
        [Locale.Ru]: `Введите название блока`,
        [Locale.Am]: `Մուտքագրեք բլոկի անվանումը`,
        [Locale.En]: `Enter the name of the block`,
        [Locale.Pt]: 'Digite o nome do bloco',
        [Locale.Ge]: `Enter the name of the block`,
    },
    collapsible: {
        [Locale.Ru]: `Сворачиваемый раздел`,
        [Locale.Am]: `Ծալվող բաժին`,
        [Locale.En]: `Collapsible section`,
        [Locale.Pt]: 'Seção dobrável',
        [Locale.Ge]: `Collapsible section`,
    },
    defaultHidden: {
        [Locale.Ru]: `Скрыт по умолчанию`,
        [Locale.Am]: `Լռելյայն թաքցված`,
        [Locale.En]: `Hidden by default`,
        [Locale.Pt]: 'Oculto por padrão',
        [Locale.Ge]: `Hidden by default`,
    },
    blockAlign: {
        [Locale.Ru]: `Выравнивание полей блока`,
        [Locale.Am]: `Բլոկի դաշտերի հավասարեցում`,
        [Locale.En]: `Aligning block fields`,
        [Locale.Pt]: 'Alinhando campos de bloco',
        [Locale.Ge]: `Aligning block fields`,
    },
    consultation: {
        [Locale.Ru]: `Консультация`,
        [Locale.Am]: `Խորհրդատվություն`,
        [Locale.En]: `Consultation`,
        [Locale.Pt]: 'Consulta',
        [Locale.Ge]: `Consultation`,
    },
    diagnostics: {
        [Locale.Ru]: `Диагностика`,
        [Locale.Am]: `Ախտորոշում`,
        [Locale.En]: `Diagnostics`,
        [Locale.Pt]: 'Diagnóstico',
        [Locale.Ge]: `Diagnostics`,
    },
    usDiagnostics: {
        [Locale.Ru]: `УЗ-Диагностика`,
        [Locale.Am]: `ՈՒՁ-ախտորոշում`,
        [Locale.En]: `Us-Diagnostics`,
        [Locale.Pt]: 'Nós-Diagnóstico',
        [Locale.Ge]: `Us-Diagnostics`,
    },
    manipulation: {
        [Locale.Ru]: `Манипуляция`,
        [Locale.Am]: `Մանիպուլյացիա`,
        [Locale.En]: `Manipulation`,
        [Locale.Pt]: 'Manipulação',
        [Locale.Ge]: `Manipulation`,
    },
    systemFem: {
        [Locale.Ru]: `Системная`,
        [Locale.Am]: `Համակարգային`,
        [Locale.En]: `System`,
        [Locale.Pt]: 'Sistema',
        [Locale.Ge]: `System`,
    },
    defaultEntryType: {
        [Locale.Ru]: `Тип записи по умолчанию`,
        [Locale.Am]: `Լռելյայն գրառման տեսակ`,
        [Locale.En]: `Default entry type`,
        [Locale.Pt]: 'Tipo de entrada padrão',
        [Locale.Ge]: `Default entry type`,
    },
    nestedEntry: {
        [Locale.Ru]: `Вложенная запись`,
        [Locale.Am]: `Ներդրված գրառում`,
        [Locale.En]: `Nested entry`,
        [Locale.Pt]: 'Entrada aninhada',
        [Locale.Ge]: `Nested entry`,
    },
    version: {
        [Locale.Ru]: `Версия`,
        [Locale.Am]: `Տարբերակ`,
        [Locale.En]: `Version`,
        [Locale.Pt]: 'Versão',
        [Locale.Ge]: `Version`,
    },
    relatedServices: {
        [Locale.Ru]: `Связанные услуги`,
        [Locale.Am]: `Կապված ծառայություններ`,
        [Locale.En]: `Related services`,
        [Locale.Pt]: 'Serviços relacionados',
        [Locale.Ge]: `Related services`,
    },
    excludedServices: {
        [Locale.Ru]: `Исключаемые услуги`,
        [Locale.Am]: `Բացառվող ծառայություններ`,
        [Locale.En]: `Excluded services`,
        [Locale.Pt]: 'Serviços excluídos',
        [Locale.Ge]: `Excluded services`,
    },
    newBlock: {
        [Locale.Ru]: `Новый блок`,
        [Locale.Am]: `Նոր բլոկ`,
        [Locale.En]: `New block`,
        [Locale.Pt]: 'Novo bloco',
        [Locale.Ge]: `New block`,
    },
    createDictionary: {
        [Locale.Ru]: `Создать словарь`,
        [Locale.Am]: `Ստեղծել բառարան`,
        [Locale.En]: `Create a dictionary`,
        [Locale.Pt]: 'Crie um dicionário',
        [Locale.Ge]: `Create a dictionary`,
    },
    tieDictionary: {
        [Locale.Ru]: `Связанный словарь`,
        [Locale.Am]: `Կապված բառարան`,
        [Locale.En]: `Related dictionary`,
        [Locale.Pt]: 'Dicionário relacionado',
        [Locale.Ge]: `Related dictionary`,
    },
    dictionaryElements: {
        [Locale.Ru]: `Элементы этого словаря`,
        [Locale.Am]: `Այս բառարանի տարրերը`,
        [Locale.En]: `Elements of this dictionary`,
        [Locale.Pt]: 'Elementos deste dicionário',
        [Locale.Ge]: `Elements of this dictionary`,
    },
    tie: {
        [Locale.Ru]: `Связь`,
        [Locale.Am]: `Կապ`,
        [Locale.En]: `Relation`,
        [Locale.Pt]: 'Relação',
        [Locale.Ge]: `Relation`,
    },
    tieWith: {
        [Locale.Ru]: `Связь с`,
        [Locale.Am]: `Կապ՝`,
        [Locale.En]: `Relation with`,
        [Locale.Pt]: 'Relação com',
        [Locale.Ge]: `Relation with`,
    },
    chooseTieDictionary: {
        [Locale.Ru]: `Выберите`,
        [Locale.Am]: `Ընտրեք`,
        [Locale.En]: `Choose`,
        [Locale.Pt]: 'Escolha',
        [Locale.Ge]: `Choose`,
    },
    newEntryType: {
        [Locale.Ru]: `Новый тип записи`,
        [Locale.Am]: `Գրառման նոր տեսակ`,
        [Locale.En]: `New entry type`,
        [Locale.Pt]: 'Novo tipo de entrada',
        [Locale.Ge]: `New entry type`,
    },
    attachedDocument: {
        [Locale.Ru]: `Прикрепленный документ`,
        [Locale.Am]: `Կցված փաստաթուղթ`,
        [Locale.En]: `Attached document`,
        [Locale.Pt]: 'Documento anexado',
        [Locale.Ge]: `Attached document`,
    },
    patientFiles: {
        [Locale.Ru]: `Файлы пациента`,
        [Locale.Am]: `Պացիենտի ֆայլեր`,
        [Locale.En]: `Patient files`,
        [Locale.Pt]: 'Arquivos de pacientes',
        [Locale.Ge]: `Patient files`,
    },
    leftAligned: {
        [Locale.Ru]: `По левому краю`,
        [Locale.Am]: `Ձախ եզրով`,
        [Locale.En]: `Left aligned`,
        [Locale.Pt]: 'Alinhado à esquerda',
        [Locale.Ge]: `Left aligned`,
    },
    inTheCenter: {
        [Locale.Ru]: `По центру`,
        [Locale.Am]: `Կենտրոնում`,
        [Locale.En]: `In the center`,
        [Locale.Pt]: 'No centro',
        [Locale.Ge]: `In the center`,
    },
    rightAligned: {
        [Locale.Ru]: `По правому краю`,
        [Locale.Am]: `Աջ եզրով`,
        [Locale.En]: `Right aligned`,
        [Locale.Pt]: 'Alinhado à direita',
        [Locale.Ge]: `Right aligned`,
    },
    fieldForEditingReferrals: {
        [Locale.Ru]: 'Поле для редактирования направлений',
        [Locale.Am]: 'Ուղեգրերի խմբագրման դաշտ',
        [Locale.En]: 'Field for editing referrals',
        [Locale.Pt]: 'Campo para edição de referências',
        [Locale.Ge]: 'Field for editing referrals',
    },
    fieldForEditingRenderedServices: {
        [Locale.Ru]: 'Поле для редактирования оказанных услуг',
        [Locale.Am]: 'Մատուցված ծառայությունների խմբագրման դաշտ',
        [Locale.En]: 'Field for editing rendered services',
        [Locale.Pt]: 'Campo para edição de serviços prestados',
        [Locale.Ge]: 'Field for editing rendered services',
    },
    // NAME: {
    //     [Locale.Ru]: ``,
    //     [Locale.Am]: ``,
    //     [Locale.En]: ``,
    // [Locale.Pt]: '',
    //     [Locale.Ge]: ``,
    // },
};
